import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AlertType } from 'src/app/core/enums/enums';
import { PnrInfo, QuoteRequest } from 'src/app/core/models/itinerary.model';
import { ContractError } from 'src/app/core/models/models';
import {
  SpecialRequestCategoryQuote,
  SpecialRequestConfirmation,
  SpecialRequestItem,
  SpecialRequestQuote,
  SpecialRequestQuoteRequest,
  SpecialRequestCategory,
} from 'src/app/core/models/special-requests.model';
import { ItineraryService } from 'src/app/search-result/services/itinerary.service';

import { SpecialRequestActions } from '../actions';
import { SpecialRequestState } from '../reducers/special-requests.reducer';
import * as fromReducers from '../reducers/special-requests.reducer';

@Injectable()
export class SpecialRequestService {
  constructor(
    private store: Store<SpecialRequestState>,
    private itineraryService: ItineraryService
  ) {}

  getOriginalCategories(): Observable<SpecialRequestCategory[]> {
    return this.store.pipe(select(fromReducers.getOriginalCategories));
  }

  getSpecialRequestCategoryQuote(): Observable<SpecialRequestCategoryQuote> {
    return this.store.pipe(select(fromReducers.getspecialRequestCategoryQuote));
  }

  getSpecialRequestQuote(): Observable<SpecialRequestQuote> {
    return this.store.pipe(select(fromReducers.getSpecialRequestQuote));
  }

  getLoading(): Observable<boolean> {
    return this.store.pipe(select(fromReducers.getLoading));
  }

  getError(): Observable<ContractError> {
    return this.store.pipe(select(fromReducers.getError));
  }

  getSuccessResponse(): Observable<SpecialRequestConfirmation[]> {
    return this.store.pipe(select(fromReducers.getSpecialRequestConfirmation));
  }

  getStepLogic(): Observable<any> {
    return this.store.pipe(select(fromReducers.getStepLogic));
  }

  getRequestState(): Observable<AlertType> {
    return this.store.pipe(select(fromReducers.getRequestState));
  }

  getOpenAccordion(): Observable<boolean> {
    return this.store.pipe(select(fromReducers.getOpenAccordion));
  }

  getQuoteRequest(): Observable<QuoteRequest> {
    return this.itineraryService.getQuoteRequest();
  }

  getPnrInfo(): Observable<PnrInfo> {
    return this.itineraryService.getPnrInfo();
  }

  goToItinerary(route: string) {
    this.itineraryService.navigateToWithParams('itinerary');
  }

  dispatchGoToStep2(specialRequestItem: SpecialRequestItem) {
    this.store.dispatch(
      SpecialRequestActions.goToStep2({ specialRequestItem })
    );
  }

  dispatchGoToStep1() {
    this.store.dispatch(SpecialRequestActions.goToStep1());
  }

  dispatchGetSpecialRequestQuote(quoteRequest: QuoteRequest) {
    this.store.dispatch(
      SpecialRequestActions.getSpecialRequestQuote({ quoteRequest })
    );
  }

  dispatchGetSpecialRequestQuoteSuccess(
    specialRequestCategoryQuote: SpecialRequestCategoryQuote
  ) {
    this.store.dispatch(
      SpecialRequestActions.getSpecialRequestQuoteSuccess({
        specialRequestCategoryQuote,
      })
    );
  }

  dispatchPostSpecialRequest(
    specialRequestQuoteRequest: SpecialRequestQuoteRequest
  ) {
    this.store.dispatch(
      SpecialRequestActions.postSpecialRequest({ specialRequestQuoteRequest })
    );
  }

  dispatchSearch(searchValue: string) {
    this.store.dispatch(
      SpecialRequestActions.searchSpecialRequest({
        searchValue,
      })
    );
  }
}
